export const popup = () => {

  const popups = document.querySelectorAll('.popup-container');
  document.addEventListener("click", (el) => {
    popups.forEach(popup => {

      const pop = popup.querySelector('.popup');
      const btn = popup.querySelector('.btn-popup');
      const containsMenu = el.composedPath().includes(pop);
      const containsMen1 = el.composedPath().includes(btn);

      if (!containsMenu && !containsMen1) {
        pop.classList.remove("open");
      }
    })
  });

  popups.forEach(popup => {
    const pop = popup.querySelector('.btn-popup');
    const close = popup.querySelector('.close');
    const pup = popup.querySelector('.popup');
    pop.addEventListener('click', (e) => {
      pup.classList.toggle('open');
    })
    close.addEventListener('click', (e) => {
      pup.classList.remove('open');
    })

  })

}
